export const moduleTypeDefs = `
/**
 * Global declarations for Upwire Playground JavaScript Modules.
 * These globals are injected by the Go module engine (Otto/Goja).
 */

declare namespace control {
    /** Completes module execution successfully. Value becomes the module output. */
    function done(value?: any): void;

    /** Signals an error and stops execution. */
    function error(message: string): void;

    /** Defers execution and schedules a rerun after the duration (e.g., "5s", "1m"). */
    function rerunAfter(duration: string | number): void;

    /** Delays the next step in the workflow without deferring the current run. */
    function delayNextStep(duration: string | number): void;

    /** Signals that the module should be retried. */
    function retry(): void;
}

/** Completes module execution successfully. Value becomes the module output. */
declare function done(value?: any): void;

/** Signals an error and stops execution. */
declare function error(message: string): void;

/** Defers execution and schedules a rerun after the duration (e.g., "5s", "1m"). */
declare function rerunAfter(duration: string | number): void;

/** Delays the next step in the workflow without deferring the current run. */
declare function delayNextStep(duration: string | number): void;

/** Signals that the module should be retried. */
declare function retry(): void;

interface DataSilo {
    /** Check if key exists */
    exists(key: string): boolean;

    /** Get value as any type */
    get(key: string): any;

    /** Get value as string */
    getString(key: string): string;

    /** Get value as integer */
    getInt(key: string): number;

    /** Get value as number/float */
    getNumber(key: string): number;

    /** Get value as boolean */
    getBool(key: string): boolean;

    /** Export all data in silo to a plain object */
    toObject(): Record<string, any>;
}

interface WritableDataSilo extends DataSilo {
    /** Set value of any type */
    set(key: string, value: any): void;

    /** Set string value */
    setString(key: string, value: string): void;

    /** Set integer value */
    setInt(key: string, value: number): void;

    /** Set numeric value */
    setNumber(key: string, value: number): void;

    /** Set boolean value */
    setBool(key: string, value: boolean): void;

    /** Increment numeric value and return new value */
    incr(key: string): number;

    /** Decrement numeric value and return new value */
    decr(key: string): number;

    /** Reset all data in this silo */
    reset(): WritableDataSilo;
}

/** Parameters passed directly to this module step. */
declare const inputs: DataSilo;
/** Persistent data specific to this module across different runs. */
declare const state: WritableDataSilo;
/** Session-level variables shared across all steps in the playground run. */
declare const vars: WritableDataSilo;

/** System-level information (e.g., user_id, run_id). */
declare const context: DataSilo;

/** Configuration settings defined for the module. */
declare const settings: DataSilo;

/** Arguments passed to the module. */
declare const args: DataSilo;

/** Resets all data access objects (all silos). */
declare function reset(): void;

/** Standard console logging. */
declare const console: {
    log(...args: any[]): void;
    info(...args: any[]): void;
    warn(...args: any[]): void;
    error(...args: any[]): void;
    debug(...args: any[]): void;
    trace(...args: any[]): void;
    dir(obj: any): void;
    assert(condition: boolean, ...args: any[]): void;
};

/** Standard fetch API (returns a Promise). */
declare function fetch(input: string | Request, init?: RequestInit): Promise<Response>;

/** Entry point for module execution. */
declare function main(): void;
`;
